export default "__VITE_ASSET__77bb3ba5__"